<script setup lang="ts">
import { reactive } from 'vue';
import { useRouter } from 'vue-router';
import Spinner from '~/components/Spinner.vue';
import { createNewProject } from '~/utilities/create-new-project';
import { toProjectPage } from '~/utilities/to-project-page';
import IconAdd from '~icons/carbon/add';

const router = useRouter();

const state = reactive({
  isCreatingNewProject: false,
});

async function navigateToNewProjectPage() {
  state.isCreatingNewProject = true;
  const newProject = await createNewProject();
  await router.push(toProjectPage(newProject));
  state.isCreatingNewProject = false;
}
</script>

<template>
  <button
    class="btn --primary --space-sm inline-flex items-center gap-2 text-sm disabled:cursor-not-allowed disabled:opacity-50"
    :disabled="state.isCreatingNewProject"
    @click="navigateToNewProjectPage"
  >
    <Spinner v-if="state.isCreatingNewProject" class="h-4 w-4 flex-none" />
    <IconAdd v-else class="-mx-1.5 text-base" />

    <span>
      <template v-if="state.isCreatingNewProject">{{ $t('buttons.creating_project') }}...</template>
      <template v-else>
        {{ $t('states.no_items_created.button_text', { noun: $t('states.noun.projects', 1) }) }}
      </template>
    </span>
  </button>
</template>

<style scoped lang="postcss"></style>
